<template>
  <div>
    <VTextField
      v-model="mutableValue.client"
      :label="$t('forms.labels.client')"
      :rules="{ required: true }"
      readonly
      outlined
    />
    <VTextField
      v-model="mutableValue.site"
      :label="$t('forms.labels.site')"
      :rules="{ required: true }"
      readonly
      outlined
    />
    <!--      massBalanceStep Info-->
    <div>
      <VTextField
        v-model="massBalanceStep.name"
        :label="$t('massBalance.modalStep.massBalanceName')"
        :rules="{ required: true }"
        readonly
        outlined
      />
      <div>
        <VSelect
          v-if="massBalanceStep.type === SIMPLIFIED"
          v-model="massBalanceStep.indicatorType"
          :label="$t('massBalance.simplified.indicatorType.title')"
          :items="indicatorTypes"
          outlined
          readonly
        />
      </div>
      <div
        v-if="massBalanceStep.type === STEAM"
        class="steamUnitStyle"
      >
        <span>{{ $t('massBalance.modalStep.selectSteamUnit') }}</span>
        <div
          class="reportUnitStyle"
        >
          <VSelect
            v-model="reportUnit.steamProductionUnit"
            :rules="{ required: true }"
            :label="$t('massBalance.modalStep.steamProductionUnit')"
            itemValue="id"
            readonly
            outlined
            :items="genericSteamProdUnit"
          />
        </div>
      </div>
      <div>
        <span>{{ $t('massBalance.modalStep.selectReport') }}</span>
        <div class="reportUnitStyle">
          <VCheckbox
            v-for="(r, index) in initialReportUnits"
            :key="index"
            v-model="reportUnit.type"
            readonly
            :rules="[v => v && v.length > 0]"
            :value="r"
            :label="$t(`massBalance.modalStep.${r}`)"
          />
        </div>
      </div>
      <div class="reportUnitStyle">
        <VSelect
          v-model="reportUnit.massUnit"
          :rules="{ required: true }"
          :label="$t('massBalance.modalStep.massUnit')"
          itemValue="id"
          readonly
          outlined
          :items="genericMassUnit"
        />
        <VSelect
          v-model="reportUnit.volumeUnit"
          :rules="{ required: true }"
          :label="$t('massBalance.modalStep.volumeUnit')"
          itemValue="id"
          readonly
          outlined
          :items="genericVolumeUnit"
          @change="emitChange"
        />
      </div>
      <div>
        <VSelect
          v-if="massBalanceType === SIMPLIFIED ? massBalanceStep.indicatorType === 'ppm' : true"
          v-model="massBalanceStep.injectionControl"
          :label="$t('massBalance.simplified.injectionControl.title')"
          itemValue="id"
          outlined
          :items="injectionControls"
        />
      </div>
    </div>
    <!--      FlowMeter Info-->
    <div>
      <span class="flowMeterTitle">
        {{ $t('massBalance.modalStep.flowmeter').toUpperCase() }}
      </span>
      <div>
        <VTextField
          v-if="massBalanceType === SIMPLIFIED"
          v-model="massBalanceData.flowMeters.flowmeterGeneralProps.name"
          :label="$t('massBalance.simplified.flowMeterName')"
          readonly
          outlined
        /><div>
          <VCheckbox
            v-if="massBalanceType === SIMPLIFIED"
            v-model="massBalanceData.flowMeters.flowmeterGeneralProps.displayMeters"
            :label="$t('massBalance.simplified.displayMeters')"
            :showCustomLabel="false"
            readonly
            outlined
          />
        </div>
      </div>
      <div class="subBarre" />
      <div
        v-for="(flow, index) in flowmeter"
        :key="index"
        class="flowMeterType"
      >
        <div>
          <div
            class="d-flex align-center"
            @click="showData(flow.type.toLowerCase())"
          >
            <v-icon
              v-if="show[flow.type.toLowerCase()]"
              large
              color="primary"
            >
              mdi-menu-down
            </v-icon>
            <v-icon
              v-else
              large
              color="primary"
            >
              mdi-menu-right
            </v-icon>
            <span>{{ $t(`massBalance.modalStep.${flow.type === TYPE_STEAM ? BOILER.toLowerCase() : flow.type.toLowerCase()}`) }}</span>
          </div>
          <div>
            <div
              v-for="(d, idx) in flow.config"
              :key="idx"
            >
              <VTextField
                v-model="d.network.name"
                :label="$t('massBalance.modalStep.network')"
                outlined
                readonly
              />
              <VAutocomplete
                v-model="d.flowmeters"
                :label="$t('massBalance.modalStep.flowmeter')"
                :items="d.flowmeters"
                itemText="name"
                outlined
                readonly
                :multiple="true"
              />
              <div class="actionStyle">
                <div
                  class="subBarre"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--      Analysis Info-->
    <div v-if="massBalanceStep.type !== SIMPLIFIED">
      <span class="flowMeterTitle">
        {{ $t('massBalance.modalStep.analysis').toUpperCase() }}
      </span>
      <div class="subBarre" />
      <div
        v-for="(analys, analysisIndex ) in analysis"
        :key="analysisIndex"
      >
        <div
          class="d-flex align-center"
          @click="showDataAnalysis(analys)"
        >
          <v-icon
            v-if="show[getKey(analys)]"
            large
            color="primary"
          >
            mdi-menu-down
          </v-icon>
          <v-icon
            v-else
            large
            color="primary"
          >
            mdi-menu-right
          </v-icon>
          <div class="typeLabel">
            <span>{{
              $t(`massBalance.modalStep.${analys.type === TYPE_STEAM ? BOILER.toLowerCase() : analys.type.toLowerCase()}`)
            }}</span>
            <span>{{ `${analys.name[userLang]} (${analys.measureUnit[userLang]})` }}</span>
          </div>
        </div>
        <div v-if="show[getKey(analys)]">
          <div
            v-for="(analysisConfig, analysisConfigIndex) in analys.config"
            :key="analysisConfigIndex"
          >
            <VTextField
              v-model="analysisConfig.network.name"
              :label="$t('massBalance.modalStep.network')"
              :required="true"
              readonly
              outlined
            />
            <VAutocomplete
              v-model="analysisConfig.component"
              :label="$t('massBalance.modalStep.component')"
              :items="analysisConfig.component"
              itemText="name"
              outlined
              readonly
              :multiple="true"
            />

            <div class="actionStyle">
              <div
                class="subBarre"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--      Products Info-->
    <div v-if="massBalanceStep.type == SIMPLIFIED ? massBalanceStep.indicatorType === 'ppm' : true">
      <span class="flowMeterTitle">
        {{ $t('massBalance.modalStep.products').toUpperCase() }}
      </span>
      <div class="subBarre" />
      <div
        v-for="(pro, indexp) in products"
        :key="indexp"
        class="flowMeterType"
      >
        <div class="pt-5">
          <VTextField
            v-model="pro.network.name"
            :required="true"
            :label="$t('massBalance.modalStep.network')"
            readonly
            outlined
          />
          <div class="productInfo">
            <VTextField
              v-model="pro.siteProduct.name"
              :required="true"
              :label="$t('massBalance.modalStep.productName')"
              class="w-input"
              readonly
              outlined
            />
            <VTextField
              v-model="pro.ppm"
              :label="$t('massBalance.modalStep.ppm')"
              class="w-input"
              readonly
              outlined
            />
            <v-switch
              v-model="pro.activeConcentration"
              class="mt-0 ml-3"
              :label="$t('massBalance.modalStep.concentration')"
              readonly
            />
          </div>
          <VAutocomplete
            v-model="pro.selectedComponents"
            :label="$t('massBalance.modalStep.component')"
            :items="pro.componentIds"
            itemText="name"
            readonly
            outlined
            :multiple="true"
          />
        </div>
        <div class="actionStyle">
          <div
            class="subBarre"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete.vue';
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect.vue';
import { STEAM } from '@/aquassist-shared/constants/types/network';
import { genericVolumes } from '@/aquassist-shared/constants/volumes';
import { MASS, VOLUME, INJECTION_CONTROLS, INDICATOR_TYPES, SIMPLIFIED } from '@/aquassist-shared/constants/massBalance';
import { TYPE_STEAM } from '../../../../aquassist-shared/constants/types/flowMeters';
import { BOILER } from '../../../../aquassist-shared/constants/types/components';

export default {
    name: 'SummaryForm',
    components: {
        VSelect,
        VAutocomplete,
        VTextField,
    },
    props: {
        mutableValue: {
            type: Object,
            default: null,
        },
        massBalanceType: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            massBalanceStep: {},
            flowmeter: [],
            products: [],
            analysis: [],
            show: {
                makeup: false,
                blowdown: false,
                feedWater: false,
                steam: false,
                all: false,
            },
            reportUnit: {},
            initialReportUnits: [MASS.toLowerCase(), VOLUME.toLowerCase()],
        };
    },
    computed: {
        ...mapGetters([
            'massBalanceData',
            'userLang',
        ]),
        TYPE_STEAM() {
            return TYPE_STEAM;
        },
        BOILER() {
            return BOILER;
        },
        STEAM() {
            return STEAM;
        },
        SIMPLIFIED() {
            return SIMPLIFIED;
        },
        genericMassUnit() {
            return this.getUnits('massUnit');
        },
        genericVolumeUnit() {
            return this.getUnits('volumeUnit');
        },
        genericSteamProdUnit() {
            return this.getUnits('steamUnit');
        },
        indicatorTypes() {
            return INDICATOR_TYPES.map(t => ({ id: t, name: this.$t(`massBalance.simplified.indicatorType.${t}`) }));
        },
        injectionControls() {
            return INJECTION_CONTROLS.map(t => ({ id: t, name: this.$t(`massBalance.simplified.injectionControl.${t}`) }));
        },


    },

    created() {
        this.loadMassBalanceSteps();
        this.updateData();
        this.emitChange();
    },
    methods: {
        getUnits(type) {
            return genericVolumes.filter(v => v.tag.includes(type)).map(p => ({
                name: this.$t(`devices.productUnitMeasure.${p.name.toLowerCase()}`),
                id: p.name.toLowerCase(),
            }));
        },
        loadMassBalanceSteps() {
            this.massBalanceStep = this.massBalanceData.massBalanceStep;
            this.flowmeter = this.massBalanceData.flowMeters.summaryData;
            this.analysis = this.massBalanceData?.analysis?.summaryData;
            this.products = this.massBalanceData?.products?.summaryData;
            const { steamProductionUnit, massUnit, volumeUnit, type } = this.massBalanceStep.reportUnit;
            this.reportUnit = {
                steamProductionUnit: steamProductionUnit.toLowerCase(),
                massUnit: massUnit.toLowerCase(),
                volumeUnit: volumeUnit.toLowerCase(),
                type: type.map(t => t.toLowerCase()),
            };
        },
        showData(flowmeterType) {
            this.show = {
                ...this.show,
                [flowmeterType]: !this.show[flowmeterType],
            };
        },
        showDataAnalysis(analysis) {
            const key = this.getKey(analysis);
            this.show = {
                ...this.show,
                [key]: !this.show[key],
            };
        },

        getKey(analysis) {
            return `${analysis.key}_${analysis.type}`;
        },
        validateSummary() {
            this.loadMassBalanceSteps();
            this.updateData();
            return !!this.flowmeter
            && !!this.massBalanceData.massBalanceStep
            && (this.massBalanceStep.type === SIMPLIFIED && this.massBalanceStep?.indicatorType !== 'ppm' ? true : !!this.massBalanceData.products);
        },
        emitChange() {
            this.$emit('inputChange', this.validateSummary);
        },
        updateData() {
            this.$emit('sendData', this.massBalanceData);
        },
    },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/massBalanceStyle.scss";
</style>
